/**
 * 
 * @param {*} amount Monto que se convertira a porcentage
 * @returns El monto en porcentage listo para aplicar a compras y ventas
 */
export const percentage = (amount) => parseFloat(parseInt(amount) / 100)